import { PropsWithChildren } from "react";

type SectionCardProps = PropsWithChildren<{
  eyebrow?: string;
  title: string;
  className?: string;
}>;

export function SectionCard({
  eyebrow,
  title,
  className,
  children,
}: SectionCardProps) {
  return (
    <section className={className ? `section-card ${className}` : "section-card"}>
      {eyebrow ? <p className="section-card__eyebrow">{eyebrow}</p> : null}
      <h2>{title}</h2>
      {children}
    </section>
  );
}
